import React from "react";
import get from "lodash/get";
import "./style.scss";
import { ReactComponent as EditIcon } from "../../assets/images/icons/pen.svg?react";
import { ReactComponent as DeleteIcon } from "../../assets/images/icons/trash.svg?react";
import { ReactComponent as SortUp } from "../../assets/images/icons/sort-up-1.svg?react";
import { ReactComponent as SortDown } from "../../assets/images/icons/sort-down-1.svg?react";
import EmptyState from "../../assets/images/icons/state-empty.svg";
import lockIcon from "assets/images/svg/lock-icon.svg";
import cx from "classnames";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import qs from "query-string";
import useTranslation from "../../hooks/useTranslation";
import Spinner from "components/Spinner/Spinner";

const Index = ({
	items = [],
	rowKey = "id",
	columns = [],
	isFetched = false,
	editAction,
	deleteAction,
	visibleEdit = true,
	visibleDelete = true,
	emptyUiText = "Список пуст",
	extraTheadRow,
	hasExtraTheadRow,
	totalRowPrepend,
	totalRowAppend,
	id = undefined,
	editComponent = null,
	onRowClick = () => { },
	getExtraClass = () => ""
}) => {
	const { tr } = useTranslation();

	const location = useLocation();
	const navigate = useNavigate();
	const query = qs.parse(location.search, { ignoreQueryPrefix: true });

	const classes = cx("devent-table", !isFetched && "--loading");

	return (
		<div className={classes}>
			{/* {!isFetched && <div className="loading-bar loading-bar--absolute" />} */}

			<table id={id}>
				<thead>
					<tr>
						{columns.map((col, i) => {
							const title = get(col, "title");
							const titleLabel = typeof title === "function" ? title() : title;
							return (
								<th key={i} className={get(col, "className")}>
									{col.sort ? (
										<div
											onClick={() => {
												let nextSort;
												if (query.sort === col.sort) {
													nextSort = "-" + col.sort;
												} else if (query.sort === "-" + col.sort) {
													nextSort = null;
												} else {
													nextSort = col.sort;
												}
												navigate({
													search: qs.stringify(
														{ ...query, sort: nextSort },
														{ encode: false }
													)
												});
											}}
											className="d-flex align-items-center"
										>
											{titleLabel}
											<div className="table-sort-ui">
												<span
													className={query.sort === col.sort ? "--active" : ""}
												>
													<SortUp />
												</span>
												<span
													className={
														query.sort === "-" + col.sort ? "--active" : ""
													}
												>
													<SortDown />
												</span>
											</div>
										</div>
									) : (
										titleLabel
									)}
								</th>
							);
						})}
						{visibleEdit && editAction && <th className="w-50" />}
						{visibleDelete && deleteAction && <th className="w-50" />}
					</tr>

					{hasExtraTheadRow && extraTheadRow()}
				</thead>

				{!isFetched ? (
					<tbody>
						<tr>
							<td colSpan={100} className="!py-10 text-center">
								<Spinner className="--large" />
							</td>
						</tr>
					</tbody>
				) : (
					<>
						{items.length > 0 && (
							<tbody>
								{totalRowPrepend && totalRowPrepend}
								{items.map((item, ind) => {
									if (!item) return null;
									const key =
										item[rowKey] !== undefined && item[rowKey] !== null
											? item[rowKey]
											: ind;
									return (
										// <tr key={key} className={getExtraClass(item)}>
										<tr
											key={key}
											className={getExtraClass(item)}
											data-row-id={item[rowKey]}
										>
											{columns.map((col, i) => (
												<td
													key={i}
													className={get(col, "className")}
													onClick={() => {
														if (!get(col, "isClickable")) {
															onRowClick(item);
														}
													}}
												>
													{col.render(item[col.dataIndex], item, ind)}
												</td>
											))}
											{editComponent ? (
												editComponent(item)
											) : visibleEdit && editAction ? (
												<td className="w-50">
													{!get(item, "is_default") && <span
														className="action-btn action-btn--info"
														onClick={() => editAction(item)}
													>
														<EditIcon />
													</span>}
												</td>
											) : null}
											{visibleDelete && deleteAction && (
												<td className="w-50">
													{!get(item, "is_default") ? <span
														className="action-btn action-btn--danger"
														onClick={() => deleteAction(item)}
													>
														<DeleteIcon />
													</span> : <img
														className="ml-[10px]"
														width={20}
														src={lockIcon}
														alt=""
													/>}
												</td>
											)}
										</tr>
									);
								})}
								{totalRowAppend && totalRowAppend}
							</tbody>
						)}
					</>
				)}
			</table>
			{isFetched && items.length < 1 && (
				<div className="devent-table__no-data">
					<img src={EmptyState} alt="" />
					{tr(emptyUiText)}
				</div>
			)}
		</div>
	);
};

export default Index;
